// Loading Page
export const PAGE_LOADER = 'PAGE_LOADER';
export const SHOW_LOGIN_WINDOW = 'SHOW_LOGIN_WINDOW';
export const SIGN_UP_WITH_DOMAIN = 'SIGN_UP_WITH_DOMAIN';
export const SHOW_SIGNUP_WINDOW = 'SHOW_SIGNUP_WINDOW';
export const SHOW_UPGRADE_WINDOW = 'SHOW_UPGRADE_WINDOW';
export const LOW_BUDGET_WINDOW = 'LOW_BUDGET_WINDOW';
export const GOOGLE_PROFILE = 'GOOGLE_PROFILE';

export const TERMS_AND_SERVICE = 'TERMS_AND_SERVICE';
export const SELL_TERMS_AND_SERVICE = 'SELL_TERMS_AND_SERVICE';
export const SELL_PRIVACY_POLICY = 'SELL_PRIVACY_POLICY';
export const UPDATE_PROFILE_WINDOW = 'UPDATE_PROFILE_WINDOW';

//Login
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGGED_USER = 'LOGGED_USER';

export const UPDATE_SEARCH_DOMAIN = 'UPDATE_SEARCH_DOMAIN';

// General
export const CATCH_ERROR = 'CATCH_ERROR';
export const ROBOT_PAGE = 'ROBOT_PAGE';
export const LOCATION_NOT_SUPPORT = 'LOCATION_NOT_SUPPORT';
export const SEARCHED_DOMAIN = 'SEARCHED_DOMAIN';
export const PAYMENT_POPUP = 'PAYMENT_POPUP';

// profile
export const GET_MY_PROFILE = 'GET_MY_PROFILE';
export const UPDATE_MY_PROFILE = 'UPDATE_MY_PROFILE';

// Lead
export const LEAD_UID = 'LEAD_UID';
export const LEAD_DETAILS = 'LEAD_DETAILS';
export const LEAD_ASSIGNED_AGENT = 'LEAD_ASSIGNED_AGENT';
export const GET_MY_LEADS = 'GET_MY_LEADS';

export const GET_REGISTRAR_LEADS = 'GET_REGISTRAR_LEADS';
export const SET_DOMAIN_NAME = 'SET_DOMAIN_NAME';
export const SET_CONTACT_US_DOMAIN = 'SET_CONTACT_US_DOMAIN';
export const SET_DOMAIN_OFFER_AMOUNT = 'SET_DOMAIN_OFFER_AMOUNT';

// COMMON
export const PREVIOUS_ACTION = 'PREVIOUS_ACTION';
export const SET_LINKEDIN_CODE = 'SET_LINKEDIN_CODE';
export const LOCAL_COUNTRY_DETAIL = 'LOCAL_COUNTRY_DETAIL';

// APPRAISAL
export const APPRAISAL_SEARCH_HISTORY = 'APPRAISAL_SEARCH_HISTORY';
export const APPRAISAL_SEARCH_HISTORY_ERROR = 'APPRAISAL_SEARCH_HISTORY_ERROR';
export const APPRAISAL_DETAIL = 'APPRAISAL_DETAIL';
export const APPRAISAL_LOADING = 'APPRAISAL_LOADING';
export const APPRAISAL_ERROR = 'APPRAISAL_ERROR';
export const APPRAISAL_LIMIT_COUNT = 'APPRAISAL_LIMIT_COUNT';
export const APPRAISAL_ALLOWANCE = 'APPRAISAL_ALLOWANCE';
export const APPRAISAL_ALLOWANCE_ERROR = 'APPRAISAL_ALLOWANCE_ERROR';
export const APPRAISAL_ALLOWANCE_LOADING = 'APPRAISAL_ALLOWANCE_LOADING';
export const RESET_APPRAISAL_SESSION = 'RESET_APPRAISAL_SESSION';
export const TODAY_APPRAISAL_LIMIT_COUNT = 'TODAY_APPRAISAL_LIMIT_COUNT';

export const ALTERNATES_LOADING = 'ALTERNATES_LOADING';
export const APPRAISAL_CERTIFICATE_DOWNLOADING = 'APPRAISAL_CERTIFICATE_DOWNLOADING';
export const ALTERNATE_DOMAINS = 'ALTERNATE_DOMAINS';

// User
export const REGISTRAR_DETAIL = 'REGISTRAR_DETAIL';
export const REGISTRAR_LIST = 'REGISTRAR_LIST';
export const ROLE_LIST = 'ROLE_LIST';

export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
export const PASSWORD_SENT_ALERT = 'PASSWORD_SENT_ALERT';
export const SHOW_PROMO_CODE = 'SHOW_PROMO_CODE';
export const SHOW_BAD_LEAD = 'SHOW_BAD_LEAD';
export const SHOW_PAYMENT_FAILED = 'SHOW_PAYMENT_FAILED';
export const SHOW_REMODEL_ALERT = 'SHOW_REMODEL_ALERT';
